module.exports = __webpack_public_path__ + "media/images/product_owners/nga_90-dd1a17f0b6e3be47367e0f264527df73.png";